import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_techwave-studio-2/artifacts/qibhv86o_Black%20and%20Green%20Modern%20Business%20Card.svg';

const SEO = ({
  title = 'Infinity Solutions Hub | Marketing Agency Las Vegas',
  description = 'One-stop shop for all your business needs. Website Development, Software Development, Social Media, Digital Marketing, SEO, PPC & Branding in Las Vegas. Call 702-605-7282 for 20% OFF!',
  keywords = 'marketing agency, web development, software development, blockchain development, social media marketing, digital marketing, SEO, PPC, branding, Las Vegas, Nevada',
  image = DEFAULT_IMAGE,
  canonical = 'https://infinitysolutionshub.com/',
  type = 'website',
  jsonLd = null,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Infinity Solutions Hub" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
